import { Form, Formik } from "formik";
import React, { useRef } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import SelectField from "../selectField/SelectField";
import {
  buttonNameConstants,
  EMPTY_STRING,
  SET_BY_TRADE_IN_MARGIN_OPTIONS,
} from "../../../constants";
import TradeFilters from "../FilterDropdowns/TradeFilters";
import ItemOrganizationSearch from "../searchField/ItemOrganizationSearch";
import DataTable from "react-data-table-component";
import { getFormatedColumns } from "../../utility";
import {
  PRICING_RULE_TYPES,
  SET_BY_MARGIN_ENUMS,
} from "../../../system/globalEnums";
import ProductConditionTagSelector from "../tags/ProductConditionTagSelector";
import SwitchButton from "../SwitchButton/SwitchButton";
import { InputNumberField } from "..";
import ModalActionButtons from "../modal/ModalActionButtons";
import {
  salesTaxValidationSchema,
  tradeInsModalValidationSchema,
  tradeInsModalWithOutCheckValidationSchema,
} from "../../validationSchema/validationSchema";
import {
  DollarIcon,
  PercentageIcon,
} from "../../../assets/icons/iconsProvider";

const AddPricingRule = ({
  isEdit,
  columns,
  setColumns,
  productTags,
  customTypes,
  setByFilter,
  selectedTags,
  editCategory,
  itemMarginUnit,
  categoriesColumn,
  searchCategories,
  customCategories,
  handleSetByChange,
  modalHandleSubmit,
  filterProductType,
  setItemMarginUnit,
  selectedCondition,
  handleSwitchChange,
  selectedCategories,
  customSubCategories,
  modalCheckBoxStatus,
  setSearchCategories,
  setFilterProductType,
  handleCategorySelect,
  productConditionList,
  setSelectedCategories,
  productMarginColumns,
  filterProductCategory,
  setSelectedCondition,
  toggleCustomTradeModal,
  handleSelectedTagsChange,
  setFilterProductCategory,
  defaultCategorySortFieldId,
  setDefaultCategorySortFieldId,
  addPricingRuleType = PRICING_RULE_TYPES.TRADE_IN_MARGIN,
  title,
}) => {
  const asyncSelectRef = useRef();
  const tradeInValidate = modalCheckBoxStatus
    ? tradeInsModalValidationSchema
    : tradeInsModalWithOutCheckValidationSchema;
  const salesTaxInitialValues = {
    setBy: isEdit ? editCategory?.setBy : SET_BY_MARGIN_ENUMS.TYPE.value,
    saleTaxRate: isEdit ? editCategory?.saleTaxRate ?? "" : "",
  };
  const tradeInInitialValues = {
    id: editCategory?.id || EMPTY_STRING,
    cashOffer: editCategory?.cashMarginPercentage || EMPTY_STRING,
    tradeOffer: editCategory?.tradeinMarginPercentage || EMPTY_STRING,
    minPrice:
      Number(editCategory?.minPriceRange) >= 0
        ? editCategory?.minPriceRange
        : "0.00",
    maxPrice:
      Number(editCategory?.maxPriceRange) >= 0
        ? editCategory?.maxPriceRange
        : "0.00",
    setBy: editCategory?.setBy || SET_BY_MARGIN_ENUMS.TYPE.value,
  };
  const onCategoryTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultCategorySortFieldId(column.id);
  };
  const isTradInMarginRule =
    addPricingRuleType === PRICING_RULE_TYPES.TRADE_IN_MARGIN;
  return (
    <Formik
      initialValues={
        isTradInMarginRule ? tradeInInitialValues : salesTaxInitialValues
      }
      validate={isTradInMarginRule ? tradeInValidate : salesTaxValidationSchema}
      onSubmit={modalHandleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form className="px-0">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0">
            <Row className="m-0 p-0">
              <Col md={12} className="p-0 mb-3">
                <SelectField
                  name="setBy"
                  label="Set By:"
                  options={SET_BY_TRADE_IN_MARGIN_OPTIONS}
                  isSearchable={false}
                  placeHolder={"Set By..."}
                  onChangeValue={handleSetByChange}
                  isDisabled={isEdit}
                />
              </Col>
              <p className="p-0">
                Apply to{" "}
                {
                  SET_BY_TRADE_IN_MARGIN_OPTIONS.find(
                    (option) => option.value === values.setBy
                  ).label
                }
                :
              </p>
              <TradeFilters
                setBy={values.setBy}
                customTypes={customTypes}
                customCategories={customCategories}
                filterProductType={filterProductType}
                customSubCategories={customSubCategories}
                setFilterProductType={setFilterProductType}
                filterProductCategory={filterProductCategory}
                setFilterProductCategory={setFilterProductCategory}
              />
              <ItemOrganizationSearch
                values={values}
                searchCategories={searchCategories}
                setByFilter={values.setBy}
                setSearchCategories={setSearchCategories}
                selectedCategories={selectedCategories}
                setSelectedCategories={setSelectedCategories}
                filterProductCategory={filterProductCategory}
                asyncSelectRef={asyncSelectRef}
                customTypes={customTypes}
                customCategories={customCategories}
              />
              <Col md={12} className="p-0 mt-2">
                <DataTable
                  className="categories-data-table"
                  columns={getFormatedColumns(
                    values.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value
                      ? productMarginColumns
                      : categoriesColumn
                  )}
                  data={selectedCategories}
                  fixedHeader={true}
                  onSort={onCategoryTableSort}
                  defaultSortFieldId={defaultCategorySortFieldId}
                />
              </Col>
              {values.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value ? (
                <>
                  <ProductConditionTagSelector
                    productTags={productTags}
                    productConditionList={productConditionList}
                    selectedCondition={selectedCondition}
                    setSelectedCondition={setSelectedCondition}
                    selectedTags={selectedTags}
                    setSelectedTags={handleSelectedTagsChange}
                    handleSelectedTagsChange={handleSelectedTagsChange}
                  />
                  {isTradInMarginRule && (
                    <Col
                      md={5}
                      className="px-0 mt-3 d-flex align-items-center gap-3 my-3"
                    >
                      <h5 className="label-modal-text-heading mb-0">
                        Percentage
                      </h5>
                      <SwitchButton
                        onSwitchChange={(id, value) => {
                          setFieldValue("cashOffer", 0);
                          setFieldValue("tradeOffer", 0);
                          setItemMarginUnit(value);
                        }}
                        isSwitchOn={itemMarginUnit}
                        id="print-label-switch"
                      />
                      <h5 className="label-modal-text-heading mb-0 text-nowrap">
                        Fixed Value
                      </h5>
                    </Col>
                  )}
                </>
              ) : (
                <>
                  {isTradInMarginRule && (
                    <>
                      <Col md={5} className="mt-3 mb-3 p-0">
                        <SwitchButton
                          onSwitchChange={handleSwitchChange}
                          label={"Set Price Range"}
                          id="setpricerange"
                          className="switch-alignment"
                          isSwitchOn={modalCheckBoxStatus}
                        />
                      </Col>
                      <Col
                        md={7}
                        className="d-flex gap-2 mt-2 mb-2 p-0 justify-content-between"
                      >
                        {modalCheckBoxStatus && (
                          <>
                            <Col md={6} className=" ps-0 ">
                              <InputNumberField
                                name="minPrice"
                                placeHolder="Min Price"
                                type="number"
                              />
                            </Col>
                            <Col md={6} className=" pe-0 ">
                              <InputNumberField
                                name="maxPrice"
                                placeHolder="Max Price"
                                type="number"
                              />
                            </Col>
                          </>
                        )}
                      </Col>
                    </>
                  )}
                </>
              )}
              <Row className=" m-0 offer-percentage-div ">
                {isTradInMarginRule ? (
                  <>
                    <Col
                      className=" ps-0 d-flex align-items-center  m-0 mb-3 "
                      md={8}
                    >
                      <span className="trade-offer-text m-0">
                        {values.setBy === !SET_BY_MARGIN_ENUMS.PRODUCT.value
                          ? "Cash Offer Percentage:"
                          : "Cash Offer"}
                      </span>
                    </Col>
                    <Col md={4} className=" pe-0 mb-3 ">
                      <InputNumberField
                        className="input-field-background-tradeIns"
                        name="cashOffer"
                        placeHolder={`00.00`}
                        type="number"
                        maxValue={itemMarginUnit ? 9999 : 100}
                        IconImage={itemMarginUnit ? DollarIcon : PercentageIcon}
                      />
                    </Col>
                    <Col
                      className=" ps-0 d-flex align-items-center  m-0 "
                      md={8}
                    >
                      <span className="trade-offer-text m-0">
                        {values.setBy === !SET_BY_MARGIN_ENUMS.PRODUCT.value
                          ? " Trade Offer Percentage:"
                          : " Trade Offer"}
                      </span>
                    </Col>
                    <Col md={4} className=" pe-0 ">
                      <InputNumberField
                        className="input-field-background-tradeIns"
                        name="tradeOffer"
                        placeHolder={`00.00`}
                        type="number"
                        maxValue={itemMarginUnit ? 9999 : 100}
                        IconImage={itemMarginUnit ? DollarIcon : PercentageIcon}
                      />
                    </Col>
                  </>
                ) : (
                  <>
                    {" "}
                    <Col
                      className="ps-0 d-flex align-items-center m-0 mb-3"
                      md={8}
                    >
                      <span className="trade-offer-text m-0">
                        Sales Tax Rate:
                      </span>
                    </Col>
                    <Col md={4} className="pe-0 mb-3">
                      <InputNumberField
                        name="saleTaxRate"
                        placeHolder="00.00"
                        type="number"
                        maxValue={100}
                        IconImage={PercentageIcon}
                        className="input-field-background-tradeIns"
                      />
                    </Col>
                  </>
                )}
              </Row>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <ModalActionButtons
              handleCloseModal={toggleCustomTradeModal}
              submitButtonLabel={
                isEdit ? buttonNameConstants.UPDATE : buttonNameConstants.SAVE
              }
              className={"m-0 d-flex gap-2"}
            />
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
};

export default AddPricingRule;
